// extracted by mini-css-extract-plugin
export default {"productDescription":"baa-z","featuredDescription":"caa-z","description":"daa-z","more":"eaa-z","descriptionSku":"faa-z"};